import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

interface AleaLabelProps extends BoxProps {
  children: React.ReactNode;
}

const AleaLabel: React.FC<AleaLabelProps> = ({ children, ...props }) => {
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      border="1px solid #C6C6C6"
      borderRadius="12px"
      px="10px"
      py="4px"
      fontSize="15px"
      lineHeight={1.2}
      fontWeight={300}
      {...props}
    >
      {children}
    </Box>
  );
};

export default AleaLabel; 